import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ContactAndAddressService } from '@services/contact-and-address/contact-and-address.service';
import { MessengerService } from '@services/messenger/messenger.service';
import { DialogService } from '@services/dialog/dialog.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EditContactDialogComponent } from '../dynamic-content/dynamic-content-edit/components/contact/edit-dialog/edit-contact-dialog.component';

@Component({
    selector: 'app-contact-and-address',
    templateUrl: './contact-and-address.component.html',
    styleUrls: ['./contact-and-address.component.scss'],
    providers: [ContactAndAddressService],
    standalone: false
})
export class ContactAndAddressComponent implements OnInit {
  public loading: boolean;
  buttons = ['contacts', 'addresses'];
  buttonsMap = { contacts: 'contact', addresses: 'address' };
  selectedTab = 'contacts';
  query: any;
  public data: any = [];

  constructor(
    private router: Router, private contactAndAddressService: ContactAndAddressService, private ms: MessengerService, private dialogService: DialogService,
    private activatedRoute: ActivatedRoute, private dialog: MatDialog
  ) {
    this.query = { OwnerOrganisationID: this.ms.getOrganisation().OrganisationID, type: this.buttonsMap[this.selectedTab] };
  }

  ngOnInit() {
    this.findContent();
  }

  async findContent() {
    this.loading = true;
    this.data = (await this.contactAndAddressService.find(0, 10000, this.query)).data;
    this.loading = false;
  }

  openTab(tab) {
    this.selectedTab = tab;
    this.query.type = this.buttonsMap[this.selectedTab];
    this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: { tab: tab } });
    this.findContent();
  }

  async add() {
    const data: any = { type: this.buttonsMap[this.selectedTab] };
    let dialogRef: MatDialogRef<EditContactDialogComponent>;
    dialogRef = this.dialog.open(EditContactDialogComponent, <any>{ width: '900px', data });
    await dialogRef.afterClosed().toPromise();
    this.findContent();
  }

  async edit(item, event: any) {
    if (event.stopPropagation) {
      event.stopPropagation();
    }
    if (event.preventDefault) {
      event.preventDefault();
    }
    const data: any = { type: this.buttonsMap[this.selectedTab] };
    data.element = JSON.parse(JSON.stringify(item));
    let dialogRef: MatDialogRef<EditContactDialogComponent>;
    dialogRef = this.dialog.open(EditContactDialogComponent, <any>{ width: '900px', data });
    await dialogRef.afterClosed().toPromise();
    this.findContent();
  }

  async remove(item, event: any) {
    if (event.stopPropagation) {
      event.stopPropagation();
    }
    if (event.preventDefault) {
      event.preventDefault();
    }
    const result = await this.dialogService.confirm('Delete this item?');
    if (!!result) {
      await this.contactAndAddressService.remove(item._id);
      this.findContent();
    }
  }
}
